import { useTranslation } from 'react-i18next'
import React from 'react'

import FullPageTemplate from '../../../../components/templates/FullPageTemplate'
import LangChanger from '../../../session/_shared/LangChanger'
import MMainMenu from '../../../menu/mainMenu/M.MainMenu'
import MPageHeader from '../../../../components/presentation/M.PageHeader'
import PageContent from './PageContent'

const MLoggedProfilePage = () => {
  const { t } = useTranslation('profiles')

  return (
    <FullPageTemplate>
      <MPageHeader title={t('profile')} footer={<LangChanger />} />
      <PageContent />
      <MMainMenu active="profile" />
    </FullPageTemplate>
  )
}

export default MLoggedProfilePage
